import { Subscription } from 'rxjs';
import { Directive, Input, TemplateRef, ViewContainerRef, OnInit, OnDestroy } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { IState } from '../store/root.reducer';

@Directive({
  selector: '[opsAuthorize]'
})
export class AuthorizeDirective implements OnInit, OnDestroy {
  private _hasView = false;
  userName: string;
  private featureCode: string;
  currenUserSubscription: Subscription;

  constructor(private viewContainer: ViewContainerRef, private templateRef: TemplateRef<Object>,
    private store: Store<IState>) { }


  @Input()
  set opsAuthorize(condition: string) {
    this.featureCode = condition;
  }

  ngOnInit() {
    this.currenUserSubscription = this.store.pipe(select((state: IState) => state.currentUser)).subscribe(currentUser => {
      if (currentUser && currentUser.contactId !== 0) {
        this.userName = currentUser.fullName;
        const found = currentUser.featuresCodes.indexOf(this.featureCode) > -1;
        if (found && !this._hasView) {
          this._hasView = true;
          this.viewContainer.createEmbeddedView(this.templateRef);
        } else if (!found && this._hasView) {
          this._hasView = false;
          this.viewContainer.clear();
        }
      }
    });
  }

  ngOnDestroy() {
    this.currenUserSubscription.unsubscribe();
  }
}
